import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as LeaveRequestActions from './leave-request.actions';
import { LeaveRequest } from './leave-request.model';
export const leaveRequestsFeatureKey = 'leaveRequests';
export interface State extends EntityState<LeaveRequest> {
    // additional entities state properties
    // [fromLeaveRequest.leaveRequestFeatureKey]: fromLeaveRequest.State;
}
export const adapter: EntityAdapter<LeaveRequest> =
    createEntityAdapter<LeaveRequest>({
        selectId: (model: LeaveRequest) => model.AuthRequestID
    });
export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});
const leaveRequestReducer = createReducer(
    initialState,
    on(LeaveRequestActions.addLeaveRequest, (state, action) =>
        adapter.addOne(action.leaveRequest, state)
    ),
    on(LeaveRequestActions.upsertLeaveRequest, (state, action) =>
        adapter.upsertOne(action.leaveRequest, state)
    ),
    on(LeaveRequestActions.addLeaveRequests, (state, action) =>
        adapter.addMany(action.leaveRequests, state)
    ),
    on(LeaveRequestActions.upsertLeaveRequests, (state, action) =>
        adapter.upsertMany(action.leaveRequests, state)
    ),
    on(LeaveRequestActions.updateLeaveRequest, (state, action) =>
        adapter.updateOne(action.leaveRequest, state)
    ),
    on(LeaveRequestActions.updateLeaveRequests, (state, action) =>
        adapter.updateMany(action.leaveRequests, state)
    ),
    on(LeaveRequestActions.deleteLeaveRequestSuccess, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(LeaveRequestActions.deleteLeaveRequestsSuccess, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(LeaveRequestActions.loadLeaveRequests, (state, action) =>
        adapter.setAll(action.leaveRequests, state)
    ),
    on(LeaveRequestActions.clearLeaveRequests, state =>
        adapter.removeAll(state)
    )
);
export function reducer(state: State | undefined, action: Action) {
    return leaveRequestReducer(state, action);
}
